import { Gauge, Send, Settings2, Target, UsersIcon, Layers } from 'lucide-react';

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail
} from '@/components/ui/sidebar';
import { NavMain } from './nav-main';
import { MerchantSwitcher } from './merchant-switcher';
import { LogoSection } from './logo-section';
import { useFeature } from '@/hooks/use-feature';
import { ThemeModeSwitcher } from './theme-mode-switcher';

export function AppSidebar() {
  const isCampaignsEnabled = useFeature('CAMPAIGNS');
  const isSegmentsEnabled = useFeature('SEGMENTS');
  const isAdminSettingsEnabled = useFeature('ADMIN_SETTINGS');

  const data = {
    main: [
      {
        name: 'Dashboard',
        url: '/dashboard',
        icon: Gauge
      },
      ...(isCampaignsEnabled
        ? [
            {
              name: 'Campaigns',
              url: '/campaigns',
              icon: Send
            }
          ]
        : []),
      ...(isSegmentsEnabled
        ? [
            {
              name: 'Segments',
              url: '/segments',
              icon: Layers
            }
          ]
        : []),
      {
        name: 'Tracking',
        url: '/tracking',
        icon: Target
      },
      {
        name: 'Profiles',
        url: '/profiles',
        icon: UsersIcon
      },
      {
        name: 'Settings',
        icon: Settings2,
        items: [
          {
            name: 'Personal Profile',
            url: '/settings/profile'
          },
          {
            name: 'Merchant',
            url: '/settings/merchant'
          },
          ...(isAdminSettingsEnabled
            ? [
                {
                  name: 'Admin Settings',
                  url: '/settings/admin'
                }
              ]
            : [])
        ]
      }
    ]
  };

  return (
    <Sidebar collapsible="icon" className="px-2 pt-3 pb-6">
      <SidebarHeader className="mb-6 px-2 group-data-[collapsible=icon]:!px-1">
        <MerchantSwitcher />
      </SidebarHeader>
      <SidebarContent className="pt-0">
        <NavMain items={data.main} />
      </SidebarContent>
      <SidebarFooter className="pb-0">
        <ThemeModeSwitcher />
        <LogoSection />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
